import { SettingComponent } from "../../components";

export default function LookupSettingPage() {
  return <SettingComponent.LookupSettingPage />;
}
